
//Dependencies
import React, { Component } from 'react';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  leyenda: {
    margin: '3em auto',
    fontSize: '1.4em'
  },
  fab: {
    marginTop: '1px',
    color: '#fff',
    backgroundColor: '#f47321',
    boxShadow:'0 0 0 0 rgba(0,0,0,0)',
    '&hover':{
      color: '#fff',
      backgroundColor: '#f47321'
    }
  }/*,
  '@media  screen and (max-width: 700px)': {
    fab: {
      width: '15em'
    }
  }*/
});

class PlazoFijoBoton extends Component {
    constructor(props){
      super(props);
    }

    render() {
      const {classes, customStyles = {},disabled = false, text} = this.props;
        
        return (
            <div className="container-btn">
                <Grid container>
                    <Grid item xs={12}>
                        <Fab
                          className={classes.fab}
                          disabled={ disabled }
                          variant="extended"
                          onClick={ this.props.doAction }
                          style={ customStyles } >
                               {text}
                        </Fab>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(PlazoFijoBoton);



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/common/components/PlazoFijoBoton.js